export const RSUITE_DATEPICKER_LOCALE = {
  sunday: 'Вс',
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Вс',
  ok: 'Ок',
  today: 'Сегодня',
  yesterday: 'Вчера',
  hours: 'Часы',
  minutes: 'Минуты',
  seconds: 'Секунды'
}
